import { render, staticRenderFns } from "./ManAllowanceUploadView.vue?vue&type=template&id=5a73a46d&"
import script from "./ManAllowanceUploadView.vue?vue&type=script&lang=js&"
export * from "./ManAllowanceUploadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports